import { collection, addDoc, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Two-way notes timeline. Append-only + void-never-delete:
// add creates a note (rules require byUid == caller); void flips `voided` only
// (rules: only the author, only the voided field; delete is denied for everyone).
export function addNote(leadId, {
  type, code, text, hasProof, channel = null, proofUrls = [],
}, actor) {
  return addDoc(collection(db, 'leads', leadId, 'notes'), {
    ts: Date.now(),
    byUid: actor?.uid ?? null,
    byName: actor?.name ?? null,
    byRole: actor?.role ?? null,
    type: type ?? 'Action',
    code: code ?? null,
    text: text ?? '',
    hasProof: Boolean(hasProof),
    channel,
    proofUrls,
    voided: false,
  });
}

export function voidNote(leadId, noteId) {
  return updateDoc(doc(db, 'leads', leadId, 'notes', noteId), { voided: true });
}
